<template>
  <button
    class="btn btn-solid"
    :class="{ 'btn-block': btnLarge }"
    type="button"
    disabled
  >
    <span
      class="spinner-border spinner-border-sm"
      role="status"
      aria-hidden="true"
    ></span>
    <slot> {{ _T('Loading') }}... </slot>
    <div :class="{ overlay: uiBlock }"></div>
  </button>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ProgressBar',
  props: {
    btnLarge: {
      type: Boolean,
      default: false,
    },
    uiBlock: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['_T', 'is_progress_bar_shown']),
  },
}
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed !important;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: hsla(0, 0%, 48%, 0.68);
  z-index: 9999;
  cursor: pointer;
}
</style>
